import { styled } from "@mui/material";

export const LoaderContainer = styled("div")`
  padding: 4em 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;
